import { TypesSortOrder } from "@pulse/pulse-rpcs/lib/types/typesSortOrder";
import { SortOrder } from "@surya-digital/leo-reactjs-material-ui";

export const getSortOrder = (
  order: SortOrder,
): TypesSortOrder.TypesSortOrder => {
  switch (order) {
    case "asc":
      return TypesSortOrder.TypesSortOrder.ASCENDING;
    case "desc":
      return TypesSortOrder.TypesSortOrder.DESCENDING;
    default:
      return order satisfies never;
  }
};
